import type {
  APIRequestConstructorParameter,
  RequestMethod,
  Headers,
  RequestData,
  URLParams,
} from './APITypes'

class APIRequest<
  THeaders extends Headers | undefined = undefined,
  TData extends RequestData = unknown,
  TURLParams extends URLParams | unknown = unknown,
> {
  data?: TData
  headers?: THeaders
  url: string
  urlParams?: TURLParams
  withCredentials: boolean
  method: RequestMethod

  constructor({
    data,
    headers,
    url,
    urlParams,
    withCredentials = false,
    method,
  }: APIRequestConstructorParameter<THeaders, TData, TURLParams>) {
    this.data = data
    this.headers = headers
    this.url = url
    this.urlParams = urlParams
    this.withCredentials = withCredentials
    this.method = method
  }
}

export default APIRequest
